import React from 'react';
import ContestLanding from '../common/ContestLanding';
import HmAjax from '../../util/HmAjax';
import $ from 'jquery';
import HmEventRegistry from '../../model/HmEventRegistry';

const JCView = "JCView";
const OCView = "OCView";

class SchoolReport extends ContestLanding {
  constructor(props) {
    super(props);
    this.state = {
      topicSubView:JCView,
      reportTabShow:false,
      reportAvailable:false,
      data:null,
      serverMessage:""
    };
    this.exportId=null;
    this.dashboardDropDownKey = "homeDropdown";
    this.topicPointClick = this.topicPointClick.bind(this);
    this.setChild(this,"CONTEST");
    this.percentile=0;
    this.contestName = "";
    this.currentTab = "";
    this.contestYear = window.contest_year || '';
  }

  componentDidMount(){
    super.componentDidMount();
    //Eligible for last accessView

    this.setLastAccessView();
    this.reportAvailableStatus();
    HmEventRegistry.fireEvent("INITIATE_GA");
    HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
  }

  formatDateFromEpoch(timestamp){
    if(!isNaN(timestamp) && timestamp > 0){
      let dt = new Date(timestamp*1000);
      try{
        let dtArr = dt.toDateString().split(" ");

        if(dtArr.length === 4){
          return dtArr[0] + ", " + dtArr[2] + " " + dtArr[1] + " " + dtArr[3];
        }
      }catch(e){
        console.error("Error occurred while trying to process the date for Result , timestamp ::" , timestamp, ", error::", e);
      }
    }
    return null;
  }

  formatTimeFromEpoch(timestamp){
    if(!isNaN(timestamp) && timestamp > 0){
       try{
       return new Date(timestamp*1000).toLocaleTimeString();
      }catch(e){
        console.error("Error occurred while trying to process the time for Result , timestamp ::" , timestamp, ", error::", e);
      }
    }
    return null;
  }

  reportAvailableStatus(){
    let me = this;
    let contestId = (this.getSelectedContestGroup()) ? this.getSelectedContestGroup().toUpperCase() : null;
    
    if(!contestId){
      return;
    }
    this.setState({serverMessage:""});
    let success = (response) => {
      console.log("reportAvailableStatus ",response)
      if(response!==null){
        if(response.status==="success"){
          me.currentTab = "JC";
          me.contestName = "RIJC_"+me.contestYear;
          me.setState({reportTabShow: true,reportAvailable:true,data:response});
          HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
        }else{  
          const reportDate = me.formatDateFromEpoch(response.resultDate);
          const reportTime = me.formatTimeFromEpoch(response.resultDate);
          if(reportTime && reportDate){
            me.setState({reportTabShow: true,reportAvailable:false,serverMessage:me.rb("tchr.result.tab.no_result").replace("{#reportDate}",reportDate).replace("{#reportTime}",reportTime)});               
          }else{
            me.setState({reportTabShow: true,reportAvailable:false,serverMessage:me.rb(response.message)});
          }            
        }
      }

    }
    
    let failure = (err) => {
      console.error("Error occurred while getting loadCurrentStep : ", err);
    }
    
    new HmAjax(this.getUrlFor("CONTEST_TIC_SCHOOL_REPORT_STATUS").replace("{#contestId}",contestId.toUpperCase())).get(success, failure);
  }

  getResults(type,e){
    //console.log("RI"+type+"_2020");
    this.checkResultStatus.apply(this,[type]);
  }

  checkResultStatus(type){
    let me = this;
    let contestId = (this.getSelectedContestGroup()) ? this.getSelectedContestGroup() : null;
    let reportType = type;
    let fileTypeArr = {
      "JC":
      ["school_stats_JC","school_marks_JC","overall_ri_stats_JC"]
      ,
      "OC":
      ["school_stats_OC","school_marks_OC","overall_ri_stats_OC"]

    }

    let fileName = fileTypeArr[this.currentTab][type-1];
    if(!contestId){
      return;
    }
    this.setState({serverMessage:""});
    let success = (response) => {
      console.log("checkResultStatus ",response)
      if(response && response.status==="success"){
        if(response && response.nextAction === "download"){
          me.downloadResults.apply(me,[contestId,reportType,fileName]);
        }else if(response && response.nextAction === "generate"){
          me.generateResults.apply(me,[contestId,reportType,fileName]);
        }
      }else {
       let msg = response.message || 'error';
       me.setState({serverMessage:me.rb(msg)});
     }
   }

   let failure = (err) => {
    console.error("Error occurred while getting loadCurrentStep : ", err);
  }

  new HmAjax(this.getUrlFor("CONTEST_TIC_SCHOOL_REPORT").replace("{#contestId}",contestId.toUpperCase()).replace("{#reportType}",reportType).replace("{#fileName}",fileName)).get(success, failure);
}

generateResults(contestId,reportType,fileName){
  let me = this;

  let success = (response) => {
    console.log("generateResults ",response)
    if(response && response.status === "success"){
      me.downloadResults.apply(me,[contestId,reportType,fileName])
    }else{
      me.setState({serverMessage:me.rb("contest.tic_report.failure")});
    }
  }

  let failure = (err) => {
    console.error("Error occurred while getting loadCurrentStep : ", err);
  }
  let contestName = this.contestName; //this.getSelectedContestGroup();
  if(reportType === 3){
    new HmAjax(this.getUrlFor("CONTEST_TIC_SCHOOL_REPORT_GEN_OV").replace("{#contestId}",contestId.toUpperCase()).replace("{#contestName}",contestName)).post(success, failure);
  }else{
    new HmAjax(this.getUrlFor("CONTEST_TIC_SCHOOL_REPORT_GEN").replace("{#contestId}",contestId.toUpperCase()).replace("{#contestName}",contestName)).post(success, failure);
  }

}

downloadResults(contestId,reportType,fileName){
      // var link = document.createElement('a');
      // document.body.appendChild(link);
      // link.href = this.getUrlFor("CONTEST_TIC_SCHOOL_REPORT_DWLD").replace("{#contestId}",contestId).replace("{#reportType}",reportType).replace("{#fileName}",fileName);
      // link.download = fileName;
      // link.click();
      // document.body.removeChild(link);
      window.open(this.getUrlFor("CONTEST_TIC_SCHOOL_REPORT_DWLD").replace("{#contestId}",contestId).replace("{#reportType}",reportType).replace("{#fileName}",fileName),"_blank");
    }

    topicPointClick(event){
      var target = event.currentTarget;
      $(".hometopmenu").removeClass("selected");
      $(target).addClass("selected");

      if($(target).hasClass("allTopics")){
        this.contestName = "RIJC_"+this.contestYear;
        this.currentTab = "JC";
        this.setState({topicSubView:JCView,serverMessage:""});
      }else if($(target).hasClass("pointssystem")){	
        this.contestName = "RIOC_"+this.contestYear;	
        this.currentTab = "OC";	
        this.setState({topicSubView:OCView,serverMessage:""});
      }
    }

    getResultDate(){
      if(this.state.data){
        let str =  (this.state.data && this.state.data.resultDate) ? this.state.data.resultDate : 0;
        let dateInfo = '';
        if(str>0){
          dateInfo = this.epochTimeFn(str)+", "+this.formatAMPM(str);
        }
        return <span className="schRepDate">{dateInfo}</span>;
      }
    }

    render() {
      let me=this;
      if(this.state.reportTabShow){
        return super.render(
        <div className="HomeComponent mt-40" id="SchoolReport">
        {
          (()=>{

            if(this.state.reportAvailable){
              return(
              <div>	
              <h3 className="headingtxt">{this.rb("schoolreport.title")}</h3>
              <div className="reportcont d-flex justify-content-center">
              <div className="reportbox">
              <div className="row">
              <div className="col-6 greyborderright jccat allTopics hometopmenu selected" onClick={this.topicPointClick}> {this.rb("schoolreport.jccategory",[this.contestYear])} </div>
              <div className="col-6 occat pointssystem hometopmenu" onClick={this.topicPointClick}>{this.rb("schoolreport.occategory",[this.contestYear])} </div>
              </div>

              <div className="btnbox">
              <div className="row reportbtn">
              <div className="col-sm-12 col-md-4">
              <div className="schoolrep" data-ga={"Report - " + this.currentTab + "- School Results"}  onClick={this.getResults.bind(this,1)}>
              <div>
              <img src="/images/contest/downloads/pdf_icon.png" alt={"School Results"}/>
              </div>

              <div>
              <span>{this.rb("schoolreport.schoolres")}</span>
              </div>

              <div>
              <i className="material-icons">get_app</i>
              </div>
              </div>
              </div>

              <div className="col-sm-12 col-md-4">
              <div className="studentrep" data-ga={"Report - " + this.currentTab + "- Student's Results"} onClick={this.getResults.bind(this,2)}>
              <div>
              <img src="/images/contest/downloads/pdf_icon.png" alt={"Student Results"}/>
              </div>
              <div><span>{this.rb("schoolreport.studentres")}</span>
              </div>
              <div><i className="material-icons">get_app</i>
              </div>

              </div>
              </div>

              <div className="col-sm-12 col-md-4">
              <div className="overallrep" data-ga= {"Report - " + this.currentTab + "- Overall Results"} onClick={this.getResults.bind(this,3)}>
              <div>
              <img src="/images/contest/downloads/pdf_icon.png" alt={"Overall Results"}/>
              </div>
              <div>
              <span>{this.rb("schoolreport.overallres")}</span>
              </div>
              <div>
              <i className="material-icons">get_app</i>
              </div>
              </div>
              </div>
              </div>
              <div className="server-messages">
              {this.state.serverMessage}
              </div>
              <div className="row notetxtinfo">
              <div className="col-12 notetxt">{this.rb("schoolreport.notetxt")}
              </div>
              </div>
              </div>

              </div>

              </div>
              </div>
              )
            }else{
              return (
              <div className="HomeComponent mt-40">
              <h3 className="headingtxt">{this.rb("schoolreport.title")}</h3>
              <div className="repnotshown">
            {/* Report will be announced on {me.getResultDate()} */}
            {this.rb(me.state.serverMessage)}
            </div>
            </div> 
            )
          }

        })()
      }  
      </div>
      )
    }
    else{

      return super.render(
      <div className="text-align-center">
      {this.showLoader()}
      </div> 
      )


    }

  }

}

export default SchoolReport;


// WEBPACK FOOTER //
// ./src/views/contest/SchoolReport.js